<template>
  <mini-card :value="$store.getters.totalLeadsClosed" subtitle="Leads Closed"
              :previousValue="$store.getters.totalLeadsClosedPrevious"
              :received="$store.getters.totalLeads"
              :previousReceived="$store.getters.totalLeadsPrevious">
    <div slot="header" class="icon-warning">
      <i class="fad fa-box-check text-success"></i>
    </div>
    <template slot="footer">
      <div class="row small">
        <a v-if="$store.getters.spiffsLeadsSetup.manageLeadsMode" class="ml-3" href="#">
          <a href="#" @click="close()"><i class="fas fa-check mr-1"/>close</a>
        </a>
        <a v-else-if="!$store.getters.spiffsLeadsSetup.spiffReceivedLeads" class="ml-3" href="#">
          <i class="fas fa-eye mr-1"/>all leads
        </a>
        <a class="mr-3 ml-auto " href="#" @click="lost()"><i class="fas fa-times mr-1"/>lost</a>
      </div>
    </template>
  </mini-card>
</template>

<script>
import MiniCard from './MiniCard.vue'
import {Lead} from 'src/classes/datamodel.js'
export default {
    name: 'Leads-Closed-MiniCard',
    components: {
      MiniCard
    },
    methods: {
      close () {
        this.$store.dispatch('openModal', {mode: 'Close', name: 'Lead'/* , object: new Lead({status: Lead._status.CLOSED.value}) */})
      },
      lost () {
        this.$store.dispatch('openModal', {mode: 'Lost', name: 'Lead'/* , object: new Lead({status: Lead._status.LOST.value}) */})
      }
    }
}
</script>

<style>

</style>